import React, { useEffect } from 'react'
import Spinner from './Spinner'
import BtnIcon from './BtnIcon'
import { ReactSVG } from 'react-svg'
import { UserStore } from '../store/userStore'
import Dialog from './Dialog'
import Card from './Card'
import Upload from './Upload'
import Btn from './Btn'
import { toast } from 'react-toastify'
import { useAxios } from '../hooks/useAxios'
import { uploadAvatar } from '../api/uploadAvatar'
import { observer } from 'mobx-react-lite'
import { validateFile } from '../utils/validateFile'

interface IProps {
  className?: string
}

const AvatarUpload = observer((props: IProps) => {
  const [file, setFile] = React.useState<File | null>(null)
  const [preview, setPreview] = React.useState<string | null>(null)
  const { loading, fire } = useAxios()

  useEffect(() => {
    if (!file) {
      setPreview(null)
      return
    }

    const objectURL = URL.createObjectURL(file)
    setPreview(objectURL)

    return () => {
      URL.revokeObjectURL(objectURL)
    }
  }, [file])

  const onFileChange = (file: File): void => {
    const res = validateFile(file)

    if (res) {
      toast.error(res)
    } else {
      setFile(file)
    }
  }

  const load = async (): Promise<void> => {
    if (!file) {
      return
    }

    const formData = new FormData()
    formData.append('avatar', file)

    const { response, error } = await fire(uploadAvatar(formData))

    if (error) {
      console.error(error.message)
      toast.error('Не удалось загрузить файл')
    } else {
      const token = response?.data ?? ''
      if (typeof token === 'string') {
        localStorage.setItem('token', token)
        UserStore.updateUserData()

        toast.success('Вы успешно сменили аватар')
      }
    }

    setFile(null)
    setPreview(null)
  }

  return (
    <div className={`avatar-upload ${props.className ?? ''}`.trim()}>
      {loading ? (
        <div className={'avatar-upload__progress'}>
          <Spinner></Spinner>
        </div>
      ) : (
        <div className={'avatar-upload__image'}>
          { UserStore.data.avatarUrl ? <img src={UserStore.data.avatarUrl} alt={'avatar'} /> : <span className='avatar-upload__fallback'></span> }
          
        </div>
      )}

      <Dialog
        className={'avatar-upload__popup-activator'}
        activator={(open) => (
          <BtnIcon
            className={loading ? 'visibility-hidden' : ''}
            onClick={async () => await open()}
            filled
            large
          >
            <ReactSVG src={'/i/svg/camera.svg'} wrapper={'span'}></ReactSVG>
          </BtnIcon>
        )}
        render={(close) => (
          <Card style={{ maxWidth: '67rem' }}>
            <header className="card-head _centered">
              <div className="card-head__title text-h3">
                Выберите изображение
              </div>
              <BtnIcon
                className={'card-head__control _right-side'}
                onClick={async () => await close()}
                filled
              >
                <ReactSVG src={'/i/svg/x.svg'} wrapper={'span'}></ReactSVG>
              </BtnIcon>
            </header>

            <div className="card-content u-flex u-flexCol u-flexAlignItemsCenter">
              {!preview ? (
                <Upload
                  onChange={onFileChange}
                  activator={(handler) => (
                    <Btn onClick={handler}>Выбрать файл</Btn>
                  )}
                ></Upload>
              ) : (
                <>
                  <div className={'avatar-upload'}>
                    <div className={'avatar-upload__image'}>
                      <img src={preview} alt={'avatar'} />
                    </div>
                  </div>
                  <div className={'u-flex mt-md-8 mt-sm-6'}>
                    <Upload
                      onChange={onFileChange}
                      activator={(handler) => (
                        <Btn outlined onClick={handler}>
                          Другой файл
                        </Btn>
                      )}
                    ></Upload>
                    <Btn
                      className={'ml-md-5 ml-sm-4'}
                      onClick={async () => {
                        void close()
                        void load()
                      }}
                    >
                      Загрузить
                    </Btn>
                  </div>
                </>
              )}
            </div>

            <footer className="card-foot u-flex u-flexJustifyCenter text-align-center">
              <span className={'text-body-small text-secondary-color'}>
                Файл должен быть в формате jpg, png и не превышать 1 Мб
              </span>
            </footer>
          </Card>
        )}
      ></Dialog>
    </div>
  )
})

export default AvatarUpload
